import { Observable } from 'rxjs';
import { RoleDTO, RolesService } from '../../../modules/admin/services/roles.service';
import { PlanLimitError } from '../../../features/plans/models/enforcement.model';
import { PlanLimitStateService } from '../../../features/plans/services/plan-limit-state.service';
import { FrontendLoggerService } from '../../../services/frontend-logger.service';
import { NotificationService } from '../../../services/notification.service';

export class UploadAccessCoordinator {
  constructor(
    private readonly roles: RolesService,
    private readonly planLimits: PlanLimitStateService,
    private readonly notifications: NotificationService,
    private readonly logger: FrontendLoggerService
  ) {}

  loadRoles(): Observable<RoleDTO[]> {
    return this.roles.list();
  }

  activeRoles(roles: RoleDTO[]): RoleDTO[] {
    return roles.filter((role) => role.active !== false);
  }

  fallbackRoles(): RoleDTO[] {
    return [
      { name: 'viewer', label: 'Visualizador', description: 'Acceso de solo lectura', active: true, generalRoleId: 1 },
      { name: 'editor', label: 'Editor', description: 'Puede editar documentos', active: true, generalRoleId: 2 },
      { name: 'admin', label: 'Administrador', description: 'Acceso completo', active: true, generalRoleId: 3 }
    ];
  }

  isBlocked(): boolean {
    return this.planLimits.isBlocking('monthly_documents_uploaded');
  }

  showLimit(error: PlanLimitError, message: string): PlanLimitError {
    this.notifications.addNotification({ type: 'warning', message, priority: 'high' });
    return error;
  }

  logLoaded(count: number, fallback: boolean): void {
    const source = fallback ? 'inicializados con fallback' : 'cargados desde /api/admin/roles';
    this.logger.info(`[UploadComponent] Roles ${source}: ${count}`);
  }

  logLoadError(error: unknown): void {
    this.logger.error('[UploadComponent] Error al cargar roles desde /api/admin/roles: ' + String(error));
  }
}
